import React from 'react';

// Temporarily disabling the EdgedocsComposer for debugging the core rendering pipeline.
// Original file backed up.

const EdgedocsComposer: React.FC<any> = () => {
    return (
        <div>EdgedocsComposer Component (Temporarily Disabled for Debugging)</div>
    );
};

export default EdgedocsComposer;
